import React from "react";
import api from "@/lib/api";
import { Heart } from "lucide-react";
import { toast } from "sonner";

export function SaveButton({ itemType, itemId, savedIds = [], onChange, className = "" }) {
  const isSaved = savedIds.includes(itemId);
  const toggle = async (e) => {
    e.stopPropagation();
    e.preventDefault();
    try {
      if (isSaved) {
        await api.delete(`/saved/${itemType}/${itemId}`);
        toast("Removed from saved");
      } else {
        await api.post("/saved", { item_type: itemType, item_id: itemId });
        toast.success("Saved");
      }
      onChange && onChange(itemId, !isSaved);
    } catch {
      toast.error("Something went wrong");
    }
  };
  return (
    <button
      onClick={toggle}
      data-testid={`save-${itemType}-${itemId}`}
      className={`grid h-9 w-9 place-items-center rounded-full bg-white/90 backdrop-blur shadow-soft transition-transform active:scale-90 ${className}`}
      aria-label="Save"
    >
      <Heart className={`h-4.5 w-4.5 transition-colors ${isSaved ? "fill-brand text-brand" : "text-ink"}`} style={{ width: 18, height: 18 }} />
    </button>
  );
}
